import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, ReactHtmlParser } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  LogoMinhaBunge,
  TextoRegras,
  ColunaRegras,
  TitRegrasPontuacao
} from './Estilos'

import BgRegras from "./Images/BgBunge.jpg";
import ImgLogoMinhaBunge from "./Images/LogoMinhaBunge.png"

function Regras(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ Tipo, setTipo ] = useState(localStorage.getItem("c_tipo"));
  const [ Cargo, setCargo ] = useState(localStorage.getItem("c_cargo"));

  const [TituloRegrasGranular, setTituloRegrasGranular] = useState("");
  const [TextoRegrasGranular, setTextoRegrasGranular] = useState("");
  
  const [TituloRegrasIndireto, setTituloRegrasIndireto] = useState("");
  const [TextoRegrasIndireto, setTextoRegrasIndireto] = useState("");

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Regras")
        PegaTextoRegras();
    }
  }, []);

  async function PegaTextoRegras() {
    
    var requestOptions = { method: 'GET', redirect: 'follow' };
    
    fetch(URLBunge + '/api/Regulamentos/ListaRegulamentosTipo/7', requestOptions)
      .then(response => response.json())
      .then(result => {
          // console.log(result);
        setTituloRegrasGranular(result.regulamentos[0].descricao);
        setTextoRegrasGranular(result.regulamentos[0].regulamento.replace(/(?:\r\n|\r|\n)/g, "<br>"));
      })
      .catch(error => console.log('error', error));
  
    
    fetch(URLBunge + '/api/Regulamentos/ListaRegulamentosTipo/8', requestOptions)
      .then(response => response.json())
      .then(result => {

        setLoading(false)
        setTituloRegrasIndireto(result.regulamentos[0].descricao);
        setTextoRegrasIndireto(result.regulamentos[0].regulamento.replace(/(?:\r\n|\r|\n)/g, "<br>"));
      })
      .catch(error => console.log('error', error));
    
  }

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={BgRegras} BackgroundMob={BgRegras} bgcolor={'#3c647d'}>
            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>
                    <LogoMinhaBunge src={ImgLogoMinhaBunge} MaxWidth={'200px'} />
                    <Clear />

                    <TitRegrasPontuacao>Regras de pontuação</TitRegrasPontuacao>
                    
                    { Tipo == 2479 || Tipo == 7 ?
                    <TextoRegras>
                        <div className={'TituloRegras'}>{ReactHtmlParser(TituloRegrasGranular)}</div>
                        <div className={'TextoRegras'}>{ReactHtmlParser(TextoRegrasGranular)}</div>
                    </TextoRegras>
                    : null }

                    { Tipo == 2277 || Tipo == 7 ?
                    <TextoRegras>
                        <div className={'TituloRegras'}>{ReactHtmlParser(TituloRegrasIndireto)}</div>
                        <div className={'TextoRegras'}>{ReactHtmlParser(TextoRegrasIndireto)}</div>
                    </TextoRegras>
                    : null }
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Regras" />
         </BackgroundImg>
    </>
  );

}

export default Regras;
